<template>
  <div class="form container">
    <div v-if="!showForm">
      <Register v-on:showFormChanged="showFormChange" />
      <Login v-on:showFormChanged="showFormChange" />
    </div>

    <div class="form-article formResponsive formHorizontal">
      <div class="formCover" v-if="!showForm"></div>

      <div class="form-article-item intro">
        <span class="tit">Submit an Entry</span>
        <br />
        <h3>to the African-European Cartography of Culture, Language and Arts</h3>
        <br />
        <p>
          We advise you to go through the whole form and read the Publication
          Guidelines [
          <a
            target="_blank"
            href="/static/pdf/190619_glossario_Submissao&Normasdepublicacao_EN.pdf"
          >pdf eng</a>
          |
          <a
            target="_blank"
            href="/static/pdf/190502_glossario_Submissao&Normasdepublicacao.pdf"
          >pdf pt</a> ]
          before starting the submission of your article.
        </p>
        <br />
        <br />
      </div>

      <div class="form-article-item choose">
        <span class="tit">Choose or Propose an Entry</span>
        <br />
        <br />
        <p>Browse the lists below in order to choose an entry</p>
        <div>
          <span class="inline tit2">Choose from all terms</span>
          <br />
          <br />
          <select
            v-model="entry.id"
            class="inline"
            @change="entry.english = '', entry.new = false, selectListLexical()"
          >
            <option label="Choose a Term"></option>
            <optgroup label="Epistemologies">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 1"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="History and Genealogy">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 2"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Cultural Practices and Performativities">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 3"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Linguistic Uses -  Terms">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 4"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Linguistic Uses - Lexical Units">
              <option
                v-for="term in apiLexicalUnits"
                :value="'lu-' + term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Arts, Literatures and imaginaries">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 5"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
          </select>
        </div>
        <br />
        <span class="tit2">or</span>
        <br />
        <br />
        <span class="tit2">Propose a New Entry</span>
        <br />
        <br />
        <div>
          <label class="inline">in english</label>
          <input
            @input="entry.id = '', entry.new = true"
            v-model="entry.english"
            class="inline"
            type="text"
            name
          />
        </div>
      </div>

      <div style="margin-top: -40px;" class="form-article-item create" v-if="entry.new">
        <span class="tit">Thematic Sections</span>
        <br />
        <br />
        <p>Associate the New Entry to a Thematic Section.</p>
        <br />
        <div class="rsform-block" style="min-height: 100px;">
          <div class="formControls">
            <div class="formBody">
              <div class="rsformgrid6">
                <p class="rsformVerticalClear">
                  <label for="Periodohistorico20" class="container2">
                    <input
                      type="radio"
                      v-model="entry.section"
                      value="1"
                      class="rsform-checkbox"
                      @input="entry.lexical = false"
                    />
                    Epistemologies
                    <span class="checkmark"></span>
                  </label>
                </p>

                <p class="rsformVerticalClear">
                  <label for="Periodohistorico20" class="container2">
                    <input
                      type="radio"
                      v-model="entry.section"
                      value="2"
                      class="rsform-checkbox"
                      @input="entry.lexical = false"
                    />
                    History and Genealogy
                    <span class="checkmark"></span>
                  </label>
                </p>

                <p class="rsformVerticalClear">
                  <label for="Periodohistorico20" class="container2">
                    <input
                      type="radio"
                      v-model="entry.section"
                      value="3"
                      class="rsform-checkbox"
                      @input="entry.lexical = false"
                    />
                    Cultural Practices
                    <span class="checkmark"></span>
                  </label>
                </p>
                <p class="rsformVerticalClear">
                  <label for="Periodohistorico20" class="container2">
                    <input
                      type="radio"
                      v-model="entry.section"
                      value="4"
                      class="rsform-checkbox"
                      @input="entry.lexical = false"
                    />
                    Linguistic Uses
                    <span class="checkmark"></span>
                  </label>
                </p>

                <p class="rsformVerticalClear">
                  <label for="Periodohistorico20" class="container2">
                    <input
                      type="radio"
                      v-model="entry.section"
                      value="5"
                      class="rsform-checkbox"
                      @input="entry.lexical = false"
                    />
                    Arts, Literatures and imaginaries
                    <span class="checkmark"></span>
                  </label>
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div class="rsform-block" v-if="entry.section == '4'">
          <div class="formControls">
            <div class="formBody">
              <div class="rsformgrid6">
                <p class="rsformVerticalClear">
                  <label for="Periodohistorico20" class="container2">
                    <input
                      type="radio"
                      v-model="entry.lexical"
                      v-bind:value="false"
                      class="rsform-checkbox"
                    />
                    Term
                    <span class="checkmark"></span>
                  </label>
                </p>
                <p class="rsformVerticalClear">
                  <label for="Periodohistorico20" class="container2">
                    <input
                      type="radio"
                      v-model="entry.lexical"
                      v-bind:value="true"
                      class="rsform-checkbox"
                    />
                    Lexical Unit
                    <h5>(word to be defined as loan word from another source language; only loans between African and European languages should be considered)</h5>
                    <span class="checkmark"></span>
                  </label>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!entry.lexical" class="form-article-item article">
        <div class="form-article-item">
          <span class="tit">Article</span>
          <br />
          <br />

          <label>
            Term
            <p>(In the language of your article)</p>
          </label>
          <input v-model="article.name_language" type="text" name />
          <br />
          <br />

          <label>
            Title
            <p>(optional)</p>
          </label>
          <input type="text" name v-model="article.title" />
          <p>You may propose a title to your article in order to clarify the focus or approach to the Term/Entry. Max. 150 carat.</p>
          <br />
          <wysiwyg v-model="article.body" />
          <br />
          <p>
            "The article can have 6500 to 7000 characters long. Please check the Norms of Publication in the Submission Guidelines document [
            <a
              target="_blank"
              href="/static/pdf/190619_glossario_Submissao&Normasdepublicacao_EN.pdf"
            >pdf eng</a>
            |
            <a
              target="_blank"
              href="/static/pdf/190502_glossario_Submissao&Normasdepublicacao.pdf"
            >pdf pt</a> ] .
            For quotations use H6 in the Headings menu.
          </p>
        </div>

        <div class="form-article-item">
          <span class="tit">Illustrations</span>
          <br />
          <br />
          <p>Optional (Maximum 1 image)</p>
          <input class="imageinput" type="file" @change="uploadImage" />
          <p>Pictures (Photos, Drawings, etc). Allowed files: .jpg .png .gif</p>
          <div class="image-consent" v-if="article.img_url">
            <label for="expressconsent0" class="container2 inline">
              <input
                type="checkbox"
                value="true"
                class="rsform-checkbox"
                v-model="article.img_auth"
              />
              <span class="checkmark"></span>
            </label>
            <p class="inline">
              The user declares that the submitted content has a Creative Commons License or is
              covered by copyright to which they have a valid license.
            </p>
          </div>
        </div>

        <div class="form-article-item">
          <span class="tit">Keywords</span>
          <br />
          <br />
          <p>Please write your keywords in english (maximum 3).</p>
          <div class="rsform-block">
            <div class="formControls">
              <div class="formBody">
                <input
                  v-model="article.keyword1"
                  type="text"
                  value
                  size="20"
                  placeholder="1."
                  class="rsform-input-box"
                />
                <p class="formDescription"></p>
              </div>
            </div>
          </div>
          <div class="rsform-block">
            <div class="formControls">
              <div class="formBody">
                <input
                  v-model="article.keyword2"
                  type="text"
                  value
                  size="20"
                  placeholder="2."
                  class="rsform-input-box"
                />
                <p class="formDescription"></p>
              </div>
            </div>
          </div>
          <div class="rsform-block">
            <div class="formControls">
              <div class="formBody">
                <input
                  v-model="article.keyword3"
                  type="text"
                  value
                  size="20"
                  placeholder="3."
                  class="rsform-input-box"
                />
                <p class="formDescription"></p>
              </div>
            </div>
          </div>
        </div>

        <div class="form-article-item">
          <span class="tit">Hyperlinks</span>
          <br />
          <br />
          <p>Choose a maximum of 3 hyperlinks to other terms.</p>
          <span class="tit2">All Terms (A-Z)</span>
          <select v-model="article.currentLink">
            <option label="Choose a Term"></option>
            <optgroup label="Epistemologies">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 1"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="History and Genealogy">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 2"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Cultural Practices and Performativities">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 3"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Linguistic Uses">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 4"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
            <optgroup label="Arts, Literatures and imaginaries">
              <option
                v-for="term in apiTerms"
                v-if="term.section_id === 5"
                :value="term.id"
              >{{ term.term_english }}</option>
            </optgroup>
          </select>
          <button @click="addLink(article.currentLink)" type="button">Add</button>
          <br />
          <ul>
            <li v-for="link in article.linkList">
              <span v-for="term in apiTerms" v-if="term.id === link">
                {{ term.term_english }} -
                <button type="button" @click="removeLink(article.currentLink)">Remove</button>
              </span>
            </li>
            <p v-if="article.linkValidation">Maximum 3 Links</p>
          </ul>
          <br />
        </div>

        <div class="form-article-item">
          <span class="tit">Bibliographic References</span>
          <br />
          <br />
          <wysiwyg v-model="article.references" />
          <br />
          <p>Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).</p>
          <p>The references must follow the Publication Guidelines.</p>
        </div>

        <div class="form-article-item">
          <span class="tit">Author</span>
          <br />
          <br />
          <span class="tit2">Name</span>
          <div>
            <input
              class="inline"
              type="text"
              placeholder="Surname"
              v-model="article.author.surname"
            />
            <input
              class="inline"
              type="text"
              placeholder="First name and middle name"
              v-model="article.author.firstName"
            />
          </div>
          <br />
          <span class="tit2">Affiliation and Funding Reference</span>
          <br />
          <textarea v-model="article.author.affiliation"></textarea>
          <p>Máx 300 carat.</p>
          <p>I agree that my e-mail be published with the signature of the article.</p>
          <div class="inline">
            <label for="expressconsent0" class="container2">
              <input
                type="radio"
                v-bind:value="true"
                class="rsform-checkbox"
                v-model="article.author.mail"
              />
              <span class="checkmark"></span>
            </label>
            <p>YES</p>
          </div>
          <div class="inline">
            <label for="expressconsent0" class="container2">
              <input
                type="radio"
                v-bind:value="false"
                class="rsform-checkbox"
                v-model="article.author.mail"
              />
              <span class="checkmark"></span>
            </label>
            <p>NO</p>
          </div>
        </div>
      </div>

      <div v-if="entry.lexical" class="form-article-item lexical">
        <div>
          <div>
            <br />
            <br />
            <br />
            <br />
            <span class="tit">Languages</span>
            <br />
            <br />
            <label class="inline">Target Language</label>
            <select
              v-model="definition.lang_occu_id"
              class="inline"
              style="width: 80px !important;"
              @change="langSelect('european')"
            >
              <option disabled value="0">European</option>
              <option
                v-for="lang in apiLanguages"
                v-if="lang.euro === 1"
                :value="lang.id"
              >{{ lang.name }}</option>
            </select>
            <select
              v-model="definition.lang_occu_id"
              class="inline"
              style="width: 80px !important;"
              @change="langSelect('african')"
            >
              <option disabled value="0">African</option>
              <option
                v-for="lang in apiLanguages"
                v-if="lang.afro === 1"
                :value="lang.id"
              >{{ lang.name }}</option>
            </select>
            <input
              style="width: 270px;"
              v-model="definition.occurrence"
              class="inline"
              type="text"
              placeholder="Write the lexical unit in the target language"
              name
            />
          </div>

          <div>
            <label class="inline">Source Language</label>
            <select
              v-model="definition.lang_orig_id"
              class="inline"
              style="width: 80px !important;"
              v-if="definition.langOriginSelected && definition.langOriginSelected == 'african'"
            >
              <option disabled value="0">European</option>
              <option
                v-for="lang in apiLanguages"
                v-if="lang.euro === 1"
                :value="lang.id"
              >{{ lang.name }}</option>
            </select>
            <select
              v-model="definition.lang_orig_id"
              class="inline"
              style="width: 80px !important;"
              v-if="definition.langOriginSelected && definition.langOriginSelected == 'european'"
            >
              <option disabled value="0">African</option>
              <option
                v-for="lang in apiLanguages"
                v-if="lang.afro === 1"
                :value="lang.id"
              >{{ lang.name }}</option>
            </select>

            <input
              style="width: 270px;"
              v-model="definition.origin"
              class="inline"
              type="text"
              placeholder="Write the lexical unit in the language of origin"
              name
            />
          </div>
        </div>

        <div class="form-article-item form-article-item-lexical">
          <span class="tit">Grammatical Category</span>
          <br />
          <br />
          <select v-model="definition.category" class="inline">
            <option disabled value="0">Choose a Category</option>
            <option v-for="cat in apiGramCategories" :value="cat.id">{{ cat.long_name }}</option>
          </select>
        </div>

        <div class="form-article-item form-article-item-lexical">
          <span class="tit">Definition</span>
          <br />
          <br />
          <wysiwyg v-model="definition.meaning" />
          <br />
          <p>Maximum of 1500 characters (total).</p>
        </div>

        <div class="form-article-item form-article-item-lexical">
          <span class="tit">Synonyms</span>
          <br />
          <br />
          <wysiwyg v-model="definition.synonyms" />
          <br />
          <p>Maximum of 100 characters (total).</p>
        </div>

        <div class="form-article-item">
          <span class="tit">Notes</span>
          <br />
          <br />
          <wysiwyg v-model="definition.notes" />
          <br />
          <p>Maximum of 1500 characters (total). These notes will be published with the definition of the lexical unit</p>
        </div>

        <div class="form-article-item">
          <span class="tit">Bibliographic References</span>
          <br />
          <br />
          <wysiwyg v-model="definition.references" />
          <br />
          <p>Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).</p>
          <p>The references must follow the Publication Guidelines.</p>
        </div>

        <div class="form-article-item">
          <span class="tit">Author</span>
          <br />
          <br />
          <span class="tit2">Name</span>
          <div>
            <input
              class="inline"
              type="text"
              placeholder="Surname"
              v-model="definition.author.surname"
            />
            <input
              class="inline"
              type="text"
              placeholder="First name and middle name"
              v-model="definition.author.firstName"
            />
          </div>
          <br />
          <span class="tit2">Affiliation and Funding Reference</span>
          <br />
          <textarea v-model="definition.author.affiliation"></textarea>
          <p>Máx 300 carat.</p>
          <p>I agree that my e-mail be published with the signature of the article.</p>
          <div class="inline">
            <label for="expressconsent0" class="container2">
              <input
                type="radio"
                v-bind:value="true"
                class="rsform-checkbox"
                v-model="definition.author.mail"
              />
              <span class="checkmark"></span>
            </label>
            <p>YES</p>
          </div>
          <div class="inline">
            <label for="expressconsent0" class="container2">
              <input
                type="radio"
                v-bind:value="false"
                class="rsform-checkbox"
                v-model="definition.author.mail"
              />
              <span class="checkmark"></span>
            </label>
            <p>NO</p>
          </div>
        </div>
      </div>

      <div class="form-article-item outro">
        <span class="tit">Terms of Use & Copyright</span>
        <br />
        <br />
        <p>I agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.</p>
        <div class="inline">
          <label for="expressconsent0" class="container2">
            <input
              checked
              type="radio"
              v-bind:value="true"
              class="rsform-checkbox"
              v-model="copyright"
            />
            <span class="checkmark"></span>
          </label>
          <p>YES</p>
        </div>
        <div class="inline">
          <label for="expressconsent0" class="container2">
            <input type="radio" v-bind:value="false" class="rsform-checkbox" v-model="copyright" />
            <span class="checkmark"></span>
          </label>
          <p>NO</p>
        </div>
      </div>
      <p>For assistance with submitting your article please contact glossary@africaneuropeanarratives.eu</p>
      <input @click="validateEntry()" value="Submit" type="submit" name />
      <br />
      <br />
      <p class="validation">{{ validation }}</p>
    </div>
  </div>
</template>

<script>
import Register from "./Register.vue";
import Login from "./Login.vue";

export default {
  data() {
    return {
      showForm: this.$store.getters.isLoggedIn,
      apiTerms: "",
      apiLanguages: "",
      apiLexicalUnits: "",
      entry: {
        id: "",
        lexical: false,
        new: false,
        english: "",
        section: ""
      },
      article: {
        name_language: "",
        title: "",
        body: "",
        img_url: "",
        img_auth: true,
        keyword1: "",
        keyword2: "",
        keyword3: "",
        currentLink: "",
        linkList: [],
        linkValidation: false,
        author: {
          surname: "",
          firstName: "",
          affiliation: "",
          mail: true
        },
        references: ""
      },
      definition: {
        id: "",
        langOriginSelected: "",
        origin: "",
        occurrence: "",
        lang_orig_id: 0,
        lang_occu_id: 0,
        category: 0,
        meaning: "",
        synonyms: "",
        notes: "",
        author: {
          surname: "",
          firstName: "",
          affiliation: "",
          mail: true
        },
        references: ""
      },
      copyright: true,
      validation: ""
    };
  },
  components: {
    Register,
    Login
  },
  methods: {
    showFormChange: function() {
      this.showForm = true;
    },
    langSelect: function(value) {
      var app = this;
      app.definition.langOriginSelected = value;
      app.definition.lang_orig_id = 0;
    },
    selectListLexical: function() {
      var app = this;
      if (typeof app.entry.id === "string") {
        app.entry.lexical = true;
        var lexId = app.entry.id.replace("lu-", "");
        app.definition.id = parseInt(lexId, 10);
        app.lexicalPlaceholder();
      } else {
        app.entry.lexical = false;
      }
    },
    lexicalPlaceholder: function() {
      var app = this;
      app.axios
        .get(process.env.API_BASE_URL + "/lexicalunits/" + app.definition.id)
        .then(response => {
          var lexical = response.data;
          app.definition.english = lexical.term_english;
          app.definition.article = lexical.term_article;
          app.definition.origin = lexical.term_orig;
          app.definition.occurrence = lexical.term_occu;
          app.definition.lang_orig_id = lexical.lang_orig_id;
          app.definition.lang_occu_id = lexical.lang_occu_id;
          app.definition.meaning = lexical.meaning;
          app.definition.synonyms = lexical.synonyms;
          app.definition.notes = lexical.notes;
          app.definition.category = lexical.gramcategory_id;
          app.definition.author.firstName = lexical.author_name;
          app.definition.author.surname = lexical.author_surname;
          app.definition.author.affiliation = lexical.author_affiliation;
          app.definition.references = lexical.references;
        });
    },
    uploadImage: function() {
      var app = this;
      const formData = new FormData();
      formData.append("imageFile", event.target.files[0]);
      let token = this.$store.state.auth.token;
      if (token) {
        let config = {
          headers: {
            Authorization: "Bearer " + token,
            "content-type": "multipart/form-data"
          }
        };
        this.axios
          .post(process.env.API_BASE_URL + "/images", formData, config)
          .then(function(response) {
            app.article.img_url = response.data.imageFile;
          });
      }
    },
    addLink: function(value) {
      var app = this;
      if (app.article.linkList.length < 3) {
        app.article.linkValidation = false;
        app.article.linkList.push(value);
      } else {
        app.article.linkValidation = true;
      }
    },
    removeLink: function(value) {
      var app = this;
      app.article.linkList.pop(value);
      app.article.linkValidation = false;
    },
    validateEntry: function() {
      var app = this;
      if (!app.entry.english && !app.entry.id) {
        app.validation = "No entry selected or proposed";
      } else if (app.entry.new && app.entry.section.length === 0) {
        app.validation = "No section selected for new entry";
      } else {
        app.validateContent();
      }
    },
    validateContent: function() {
      var app = this;
      if (!app.entry.lexical) {
        app.validateArticle();
      } else {
        app.validateLexical();
      }
    },
    validateArticle: function() {
      var app = this;
      if (app.article.body === "") {
        app.validation = "Article body field is empty";
      } else if (app.article.img_url && !app.article.img_auth) {
        app.validation =
          "Missing Creative Commons License declaration on image upload";
      } else if (app.article.references === "") {
        app.validation = "Bibliographic references is empty";
      } else if (app.article.author.firstName === "") {
        app.validation = "Author First Name is empty";
      } else if (app.article.author.surname === "") {
        app.validation = "Author Surname is empty";
      } else if (app.copyright === "false") {
        app.validation =
          "You must agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.";
      } else {
        app.createNewTerm();
      }
    },
    createNewTerm: function() {
      var app = this;
      if (app.entry.new) {
        let token = this.$store.state.auth.token;
        if (token) {
          let config = {
            headers: { Authorization: "Bearer " + token }
          };
          app.axios
            .post(
              process.env.API_BASE_URL + "/terms",
              {
                term_english: app.entry.english,
                term_article: app.entry.english,
                definition: "No Definition",
                section_id: app.entry.section
              },
              config
            )
            .then(function(response) {
              app.entry.id = response.data.id;
              app.submitArticle();
            }, config)
            .catch(function(error) {
              app.validation = error;
            });
        }
      } else {
        app.submitArticle();
      }
    },
    submitArticle: function() {
      var app = this;
      let token = this.$store.state.auth.token;
      if (token) {
        let config = {
          headers: { Authorization: "Bearer " + token }
        };
        this.axios
          .post(
            process.env.API_BASE_URL + "/articles",
            {
              title: app.article.title,
              term_org: app.article.name_language,
              text: app.article.body,
              term_id: app.entry.id,
              // EDIÇAO
              // edition_id: 1,
              author_name: app.article.author.firstName,
              author_surname: app.article.author.surname,
              author_affiliation: app.article.author.affiliation,
              author_pub_auth: true,
              img_url: app.article.img_url,
              references: this.article.references,
              keywords: [
                app.article.keyword1,
                app.article.keyword2,
                app.article.keyword3
              ],
              links: app.article.linkList
            },
            config
          )
          .then(function(response) {
            app.validation = response.data;
            app.$router.push("/article/" + response.data.id);
          })
          .catch(function(error) {
            app.validation = error;
          });
      }
    },
    validateLexical: function() {
      var app = this;
      if (app.definition.lang_occu_id === 0) {
        app.validation = "No target language selected";
      } else if (app.definition.lang_orig_id === 0) {
        app.validation = "No source language selected";
      } else if (app.definition.category === "") {
        app.validation = "You must select a grammatical category";
      } else if (app.definition.references === "") {
        app.validation = "Bibliographic references is empty";
      } else if (app.definition.author.firstName === "") {
        app.validation = "Author First Name is empty";
      } else if (app.definition.author.surname === "") {
        app.validation = "Author Surname is empty";
      } else if (app.copyright === "false") {
        app.validation =
          "You must agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.";
      } else {
        app.submitLexical();
      }
    },
    submitLexical: function() {
      var app = this;
      if (app.entry.new) {
        let token = this.$store.state.auth.token;
        if (token) {
          let config = {
            headers: { Authorization: "Bearer " + token }
          };
          app.axios
            .post(
              process.env.API_BASE_URL + "/lexicalunits",
              {
                term_english: app.entry.english,
                term_article: app.entry.english,
                term_orig: app.definition.origin,
                term_occu: app.definition.occurrence,
                lang_orig_id: app.definition.lang_orig_id,
                lang_occu_id: app.definition.lang_occu_id,
                meaning: app.definition.meaning,
                synonyms: app.definition.synonyms,
                notes: app.definition.notes,
                gramcategory_id: app.definition.category,
                author_name: app.definition.author.firstName,
                author_surname: app.definition.author.surname,
                author_affiliation: app.definition.author.affiliation,
                author_pub_auth: true,
                references: app.definition.references
              },
              config
            )
            .then(function(response) {
              app.entry.id = response.data.id;
              app.$router.push("/lexical/" + response.data.id);
            })
            .catch(function(error) {
              app.validation = error;
            });
        }
      } else {
        let token = this.$store.state.auth.token;
        if (token) {
          let config = {
            headers: { Authorization: "Bearer " + token }
          };
          app.axios
            .patch(
              process.env.API_BASE_URL + "/lexicalunits/" + app.definition.id,
              {
                term_english: app.definition.english,
                term_article: app.definition.article,
                term_orig: app.definition.origin,
                term_occu: app.definition.occurrence,
                lang_orig_id: app.definition.lang_orig_id,
                lang_occu_id: app.definition.lang_occu_id,
                meaning: app.definition.meaning,
                synonyms: app.definition.synonyms,
                notes: app.definition.notes,
                gramcategory_id: app.definition.category,
                author_name: app.definition.author.firstName,
                author_surname: app.definition.author.surname,
                author_affiliation: app.definition.author.affiliation,
                author_pub_auth: true,
                references: app.definition.references
              },
              config
            )
            .then(function(response) {
              app.$router.push("/lexical/" + app.definition.id);
            })
            .catch(function(error) {
              app.validation = error;
            });
        }
      }
    }
  },
  mounted() {
    let app = this;

    app.axios.get(process.env.API_BASE_URL + "/terms").then(response => {
      app.apiTerms = response.data;
    });
    app.axios.get(process.env.API_BASE_URL + "/languages").then(response => {
      app.apiLanguages = response.data;
    });
    app.axios
      .get(process.env.API_BASE_URL + "/gramcategories")
      .then(response => {
        app.apiGramCategories = response.data;
      });
    app.axios.get(process.env.API_BASE_URL + "/lexicalunits").then(response => {
      app.apiLexicalUnits = response.data;
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.form {
  .tit {
    display: table;
    margin: 50px 0 10px 0;
  }

  h3 {
    font-size: 20px;
    margin-top: -15px;
  }

  .formResponsive {
    position: relative;
    .formCover {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.5);
      z-index: 9990;
    }

    .lexical {
      .form-article-item-lexical {
        padding: 0;
      }
    }

    a {
      text-decoration: underline;
      color: black;
      &:hover {
        color: black;
        text-decoration: none;
      }
    }

    h5 {
      font-size: 10px;
    }

    label {
      float: none;
    }

    .validation {
      color: red !important;
    }

    select,
    input[type="text"] {
      height: 25px;
    }

    .image-consent {
      display: flex;
      max-width: 500px;
    }

    .imageinput {
      height: 80px;
      width: 200px;
      background-image: url(/static/img/icons/photo2.png);
      background-size: 80px;
      background-repeat: no-repeat;
      background-position: left center;
      padding-top: 30px;
      cursor: pointer;

      &:hover {
        background-color: #fdee21;
      }

      &::-webkit-file-upload-button {
        visibility: hidden;
      }

      &::before {
        content: "";
        display: inline-block;
      }
    }

    input[type="radio"],
    input[type="checkbox"] {
      position: relative;
      z-index: 9999;
      margin-right: 0;
      margin-left: -15px;
    }
    .inline {
      display: inline-flex;
      margin-right: 15px;
    }
    input[type="submit"] {
      background: white;
      border: 1px solid #000;
      border-radius: 0;
      color: #000;
      text-shadow: none;
      font-size: 18px;
      padding: 10px;
      display: inline-block;
      &:hover {
        color: #000;
        background-color: #fdee21;
      }
    }
  }
  &-article {
    &-item {
      padding: 30px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Submit.vue?108d1b6f